import { toRefs, computed } from 'vue';
import { useTheme } from '../../compositions/component-lib.esm7.js';
import { getThemeColor } from '../../styles/theme/component-lib.esm3.js';
import { size } from '../../styles/component-lib.esm.js';

//

/**
 * A colored shape to use as a placeholder.
 */
var script = {
  props: {
    color: {
      type: String,
      default: '#ebebeb'
    },
    /** How many text lines should show up */
    count: {
      type: Number,
      default: 1
    },
    /* Add a `50%` border radius to the skeleton. This will only be applied if a height and width are present. */
    circle: Boolean,
    /* Change the css display to `block`. This will only be applied if a height and width are present. */
    block: Boolean,
    height: String,
    width: String
  },
  setup(props) {
    const {
      color,
      circle,
      block,
      height,
      width
    } = toRefs(props);
    const theme = useTheme();
    const styles = computed(() => {
      const baseColor = getThemeColor(color.value, theme.value);
      return {
        '--c-color': baseColor,
        '--c-height': height.value && size(height.value, theme.value),
        '--c-width': width.value ? size(width.value, theme.value) : '100%'
      };
    });
    const classes = computed(() => {
      return {
        'v-shape--circle': circle.value && height.value && width.value,
        'v-shape--block': block.value && height.value && width.value
      };
    });
    return {
      styles,
      classes
    };
  }
};
export { script as default };